import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyCEgw0qhMRoNC2FhlqetQmhVDsdYF2nu8g',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'snap-scrap-ltd-935fb.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'snap-scrap-ltd-935fb',
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'snap-scrap-ltd-935fb.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '197856427062',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:197856427062:web:f910dd5b144bce1072ac97',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-RJ5ZRN80P1',
};

const app = initializeApp(firebaseConfig);

let analytics = null;

export async function initAnalytics() {
  if (typeof window === 'undefined') return null;
  const supported = await isSupported();
  if (!supported) return null;
  analytics = getAnalytics(app);
  return analytics;
}

export { app, analytics };
